const initState = {
  productTypesError: null,
  productTypes: [],
  productTypesCorners: [],
};

const productTypesReducer = (state = initState, action) => {
  switch (action.type) {
    case 'GET_PRODUCT_TYPES_ERROR':
      return {
        ...state,
        dimensionsError: action.data,
      };

    case 'GET_PRODUCT_TYPES_SUCCESS':
      let corners = action.data
        .filter(item => {
          return [9, 10, 11].indexOf(item.id) !== -1;
        })
        .reverse();

      return {
        ...state,
        productTypes: action.data,
        productTypesCorners: corners,
        productTypesError: null,
      };
    default:
      return state;
  }
};

export default productTypesReducer;
